
import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { T4SlipSummarySetup } from "../../../components/T4Slip";

export interface IT4SlipSummarySetupPage {}

export const T4SlipSummarySetupPage: FC<IT4SlipSummarySetupPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="T4 Summary"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Compliance", navigateTo: "/compliance/t4/list" },
        // { text: "T4", navigateTo: "/compliance/t4/list" },
        // { text: "T4 Summary", navigateTo: "/compliance/t4/summary" },
      ]}
      mainContents={<T4SlipSummarySetup testId="t4-summary-setup" />}
    />
  );
};
